import { useState } from 'react';

export const usePaymentsSearch = () => {
  const [currencySearch, setCurrencySearch] = useState('');
  const [clientSearch, setClientSearch] = useState('');
  const [paymentMethodSearch, setPaymentMethodSearch] = useState('');
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);

  const clearSearch = () => {
    setCurrencySearch('');
    setClientSearch('');
    setPaymentMethodSearch('');
    setDateFrom(null);
    setDateTo(null);
  };

  const clearCurrencySearch = () => {
    setCurrencySearch('');
  };

  const clearClientSearch = () => {
    setClientSearch('');
  };

  const clearPaymentMethodSearch = () => {
    setPaymentMethodSearch('');
  };

  const clearDateRange = () => {
    setDateFrom(null);
    setDateTo(null);
  };

  return {
    currencySearch,
    setCurrencySearch,
    clientSearch,
    setClientSearch,
    paymentMethodSearch,
    setPaymentMethodSearch,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    clearSearch,
    clearCurrencySearch,
    clearClientSearch,
    clearPaymentMethodSearch,
    clearDateRange,
  };
};
